module.exports = __webpack_public_path__ + "img/icon1.c26c0a46.png";